<template>
    <b-container fluid class="advert w-100 m-0 p-0 flex-center" :class="'adam-' + variant">
        <div v-if="current" class="crop-img">
            <template v-for="advert in adverts">
                <video v-if="advert.type.id === 4"
                       :class="{'bb-hidden' : current.id !== advert.id }"
                       type="video"
                       muted
                       :src="advertPath + advert.file_path"
                       :ref="'adamvid' + advert.id"
                       @ended="setCurrent">
                </video>
                <b-img :class="{'bb-hidden' : current.id !== advert.id }"
                       fluid
                       v-else
                       :src="advertPath + advert.file_path">
                </b-img>
            </template>
        </div>
        <div v-else class="adam-placeholder p-4">
            Nema aktivnih reklama!<br/>
            <!--Oglašavajte se 063/123-456 !<br/>-->
        </div>

    </b-container>
</template>

<script>
    export default {
        name: 'adam',
        data() {
            return {
                counter: 0,
                current: null,
                adverts: []
            }
        },
        props: {
            variant: {
                type: String,
                default: 'default'
            },
            company: {
                type: String,
                default: null
            }
        },
        computed: {
            advertPath() {
                return api.advertsPath;
            },
            user() {
                return this.$store.getters.getUser;
            }
        },
        methods: {
            setCurrent() {
                if (this.adverts != null && this.adverts.length !== 0) {
                    let advert = this.adverts[this.counter];
                    this.current = advert;
                    this.incrementCounter();
                    if (advert.type.id !== 4 ) {
                        setTimeout(() => {
                            this.setCurrent()
                        }, advert.type.duration * 1000);
                    } else {
                        this.$refs["adamvid" + this.current.id][0].play();
                    }
                }
            },
            incrementCounter() {
                if (this.counter === this.adverts.length - 1) {
                    this.counter = 0;
                } else {
                    this.counter++;
                }
            },
            getAdverts() {
                let data = {};
                if (this.company) {
                    data = {
                        params: {
                            company: this.company
                        }
                    }
                }
                adamApi.get(api.adverts + 'active', data).then(response => {
                    if (response.status === 200) {
                        this.adverts = response.data;
                        if (this.current == null) {
                            this.setCurrent();
                        }
                    }
                });
            }
        },
        mounted() {
            this.getAdverts();
            var self = this;
            setInterval(function() {
                self.getAdverts();
            }, 10*1000);
        }
    }
</script>

<style lang="scss" scoped>
    .bb-hidden {
        display: none;
    }

    .advert {
        color: #FFF;
        background: #101010;
        min-height: 100vh;
        overflow: hidden;
        .adam-placeholder {
            background: rgba(255, 255, 255, .1);
            border-radius: 10px;
        }
    }

    .adam-hub {
        background: white;
        img, video {
            width: 40vw;
        }
        .crop-img {
            max-height: 50vh;
        }
    }

    .adam-default {
        img, video {
            width: 100vw;
        }
        .crop-img {
            max-height: 100vh;
        }
    }
</style>
